import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../GlobalContext'
import CustTable from '../../Common/CustTable'
import dayjs from 'dayjs'
import { Spin } from 'antd'
import { get } from '../../Common/api'
import { chatColumns } from './chatColumns'

export default function AllChatsTab () {
  const { notificationApi, boxes } = useContext(GlobalContext)
  const [chats, setChats] = useState([])
  const [loading, setLoading] = useState(false)

  const getChats = async () => {
    setLoading(true)
    await get({
      url: 'admin/chats',
      notification: { api: notificationApi, state: 'get' },
      params: { filter: 'week' },
      onSuccess: (res) => {
        setChats(res.filter((chat) => chat.last_message != null))
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getChats()
  }, [])

  console.log(chats)

  return (
    <Spin spinning={loading}>
      <CustTable
        style={{ height: 'calc(100vh - 350px)' }}
        height={700}
        initColumns={chatColumns(boxes)}
        dataSource={chats.sort((a, b) => dayjs(b.last_message?.created_at).diff(dayjs(a.last_message?.created_at)))}
        key={'id'}
      />
    </Spin>
  )
}
